import FilterHolder from './FilterHolder';

export default FilterHolder;
